module.exports = __webpack_public_path__ + "img/14.9463c5a5.png";